<script lang="typescript">
    export let classNames;
</script>

<svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 986.83 264.78"
    xml:space="preserve"
    class={classNames}
>
    <path
        class="cls-1"
        d="M78.27,156.72,56.79,89.33c-.29-1,.09-1.71,1-1.71h9.7a1.52,1.52,0,0,1,1.52,1.14l18,60.83h3.8l18-60.83a1.44,1.44,0,0,1,1.52-1.14h9.12c1,0,1.34.76,1,1.71L99,156.72a1.62,1.62,0,0,1-1.52,1.14H79.79a1.61,1.61,0,0,1-1.52-1.14m52.51,1.14a1.35,1.35,0,0,0,1.43-1.42V109.86a1.33,1.33,0,0,0-1.43-1.33H123a1.41,1.41,0,0,0-1.52,1.33v46.58a1.37,1.37,0,0,0,1.52,1.42h7.79m27.62,1.24c11.22,0,20.62-3.52,20.62-15.87,0-12.55-8.55-13.88-16.44-15.12-5.89-.85-11-1.42-11-6.94,0-5.22,5.13-6.56,10.55-6.56A75.41,75.41,0,0,1,175,116.23c.76.1,1.24-.19,1.33-.85l.86-5.14a1.2,1.2,0,0,0-1.05-1.42,57.94,57.94,0,0,0-15.39-2.09c-8.37,0-20,2.18-20,15.2,0,12.08,9.69,13.69,16.44,14.83,6.37,1.14,11,1.05,11,7.42,0,5-4.27,7-10.55,7a52.86,52.86,0,0,1-14.63-2.47,2.39,2.39,0,0,0-.67-.1c-.57,0-.85.38-1,1.05l-1,5c-.19.66.38,1.14.86,1.33a53.07,53.07,0,0,0,17.2,3m37.95-1.24a1.35,1.35,0,0,0,1.43-1.42V109.86a1.33,1.33,0,0,0-1.43-1.33h-7.79a1.41,1.41,0,0,0-1.52,1.33v46.58a1.37,1.37,0,0,0,1.52,1.42h7.79m33.28-43.34c11.5,0,12,6.75,12,18.44s-.48,18.35-12,18.35-12.07-6.75-12.07-18.35.48-18.44,12.07-18.44m0,44.58c20.63,0,23.1-11.69,23.1-26.14s-2.47-26.23-23.1-26.23S206.44,118.42,206.44,133,209,159.1,229.63,159.1m72.95-1.24a1.35,1.35,0,0,0,1.43-1.42V120.89c0-10.93-6.09-14.16-17.68-14.16a81.57,81.57,0,0,0-19.49,2.66c-5.13,1.61-6.37,3-6.37,6.65v40.4a1.43,1.43,0,0,0,1.52,1.42h7.89a1.35,1.35,0,0,0,1.43-1.42V116.52a60.78,60.78,0,0,1,14.07-2c5.6,0,7.79,1.9,7.79,7.8v34.12a1.37,1.37,0,0,0,1.52,1.42h7.89m14-1.52a1.58,1.58,0,0,0,1.62,1.52H362.8a1.48,1.48,0,0,0,1.42-1.52v-6.18a1.39,1.39,0,0,0-1.42-1.42H328.2V126h32.41A1.43,1.43,0,0,0,362,124.5v-6.18a1.35,1.35,0,0,0-1.43-1.42H328.2V96.74h34.5a1.41,1.41,0,0,0,1.52-1.42V89.14a1.5,1.5,0,0,0-1.52-1.52H318.22a1.59,1.59,0,0,0-1.62,1.52v67.2m101.17.48a1.54,1.54,0,0,0-.28-.86l-17.21-23.85L416.06,110a1.29,1.29,0,0,0,.19-.76,1.17,1.17,0,0,0-.95-1.24h-8.74a2.2,2.2,0,0,0-2.28,1.24l-10.46,17-10.93-17a2.43,2.43,0,0,0-2.38-1.24h-8.84a1.08,1.08,0,0,0-.95,1.14,1.85,1.85,0,0,0,.29.86l15.49,22.33L369.39,156a1.43,1.43,0,0,0-.19.86,1,1,0,0,0,.95,1h9.41a1.94,1.94,0,0,0,1.52-.85l12.26-18.92L406,157a1.76,1.76,0,0,0,1.42.85h9.32a1,1,0,0,0,1-1m27.3-42.11c8,0,11.79,1.71,11.79,18.16,0,14.63-3.14,18.53-12.64,18.53a39,39,0,0,1-10.55-1.33V116.52a51.46,51.46,0,0,1,11.4-1.81m1.33,44.39c17.49,0,21.48-9.89,21.48-26.14,0-15.3-2.47-26.23-20.43-26.23a61.8,61.8,0,0,0-19,3c-4.47,1.52-5.61,3-5.61,7.6v59a1.36,1.36,0,0,0,1.71,1.42l7.7-1.52a1.53,1.53,0,0,0,1.43-1.71V157.66a46.59,46.59,0,0,0,12.74,1.44m34.23-49.77c-4.09,1.33-5.8,2.56-5.8,6.46v40.49a1.35,1.35,0,0,0,1.42,1.43h8a1.35,1.35,0,0,0,1.42-1.43V116.65a59.29,59.29,0,0,1,14.55-1.53c1.14,0,1.33-.66,1.33-1.42v-5.42c0-1.42-1.05-1.61-2.19-1.61a67.14,67.14,0,0,0-18.72,2.66m55.79,12.51a34.73,34.73,0,0,1,.86,9H513.42a42.48,42.48,0,0,1,.86-9.22c1.23-5.32,4.27-7.23,11.21-7.23,6.37,0,9.51,1.81,10.93,7.42m11.7,14.73c.09-1.42.09-3.32.09-4.56,0-7.41-.86-13.4-3.8-17.68-3.42-4.94-9.22-7.6-18.92-7.6-18.63,0-23,9.12-23,26.33,0,18.15,6.65,26,25.29,26a48.2,48.2,0,0,0,16.91-2.95c.57-.28,1-.66,1-1.33a2,2,0,0,0-.1-.57l-.95-4.27c-.19-1-.66-1-1.23-1a2.28,2.28,0,0,0-.67.09,46.54,46.54,0,0,1-13.59,2.29c-5.7,0-9.6-.86-12.26-3.43-2.28-2.18-3.42-4.84-3.52-9.5H546.5a1.7,1.7,0,0,0,1.62-1.81m23.06,22.53c11.22,0,20.63-3.52,20.63-15.87,0-12.55-8.56-13.88-16.45-15.12-5.89-.85-11-1.42-11-6.94,0-5.22,5.13-6.56,10.55-6.56a75.41,75.41,0,0,1,12.92,1.62c.76.1,1.24-.19,1.33-.85l.86-5.14a1.2,1.2,0,0,0-1-1.42,57.94,57.94,0,0,0-15.39-2.09c-8.37,0-20,2.18-20,15.2,0,12.08,9.69,13.69,16.44,14.83,6.37,1.14,11,1.05,11,7.42,0,5-4.28,7-10.56,7a52.86,52.86,0,0,1-14.63-2.47,2.39,2.39,0,0,0-.67-.1c-.57,0-.86.38-1,1.05l-1,5c-.19.66.38,1.14.86,1.33a53.07,53.07,0,0,0,17.2,3m42.7,0c11.21,0,20.62-3.52,20.62-15.87,0-12.55-8.55-13.88-16.44-15.12-5.89-.85-11-1.42-11-6.94,0-5.22,5.14-6.56,10.56-6.56a75.41,75.41,0,0,1,12.92,1.62c.76.1,1.24-.19,1.33-.85l.86-5.14a1.21,1.21,0,0,0-1.05-1.42,58.05,58.05,0,0,0-15.4-2.09c-8.36,0-20,2.18-20,15.2,0,12.08,9.7,13.69,16.45,14.83,6.36,1.14,11,1.05,11,7.42,0,5-4.27,7-10.55,7a52.86,52.86,0,0,1-14.63-2.47,2.48,2.48,0,0,0-.67-.1c-.57,0-.86.38-1,1.05l-1,5c-.19.66.38,1.14.85,1.33a53.15,53.15,0,0,0,17.21,3"
    /><path class="cls-2" d="M804.49,94.1a7,7,0,1,0,7,7,7,7,0,0,0-7-7" /><path
        class="cls-2"
        d="M786.08,100.08a7,7,0,1,0,7,7,7,7,0,0,0-7-7"
    /><path class="cls-2" d="M774.69,115.75a7,7,0,1,0,7,7,7,7,0,0,0-7-7" /><path
        class="cls-2"
        d="M791.87,188.43a8.18,8.18,0,1,1,8.18-8.18,8.18,8.18,0,0,1-8.18,8.18"
    /><path
        class="cls-2"
        d="M744.16,177a7.57,7.57,0,1,1,7.57-7.57,7.56,7.56,0,0,1-7.57,7.57"
    /><path
        class="cls-2"
        d="M768.72,182.13A8.18,8.18,0,1,1,776.9,174a8.17,8.17,0,0,1-8.18,8.18"
    /><path class="cls-2" d="M804.49,170.68a7,7,0,1,1,7-7,7,7,0,0,1-7,7" /><path
        class="cls-2"
        d="M786.08,164.7a7,7,0,1,1,7-7,7,7,0,0,1-7,7"
    /><path class="cls-2" d="M774.69,149a7,7,0,1,1,7-7,7,7,0,0,1-7,7" /><path
        class="cls-2"
        d="M700.57,155.47a5.53,5.53,0,1,1,5.53-5.53,5.53,5.53,0,0,1-5.53,5.53"
    /><path
        class="cls-2"
        d="M720.05,166.38a6.67,6.67,0,1,1,6.66-6.67,6.66,6.66,0,0,1-6.66,6.67"
    /><path class="cls-2" d="M822.9,100.08a7,7,0,1,1-7,7,7,7,0,0,1,7-7" /><path
        class="cls-2"
        d="M834.28,115.75a7,7,0,1,1-7,7,7,7,0,0,1,7-7"
    /><path
        class="cls-2"
        d="M817.1,188.43a8.18,8.18,0,1,0-8.17-8.18,8.19,8.19,0,0,0,8.17,8.18"
    /><path
        class="cls-2"
        d="M864.81,177a7.57,7.57,0,1,0-7.57-7.57,7.56,7.56,0,0,0,7.57,7.57"
    /><path
        class="cls-2"
        d="M840.25,182.13a8.18,8.18,0,1,0-8.17-8.18,8.17,8.17,0,0,0,8.17,8.18"
    /><path class="cls-2" d="M822.9,164.7a7,7,0,1,0-7-7,7,7,0,0,0,7,7" /><path
        class="cls-2"
        d="M834.28,149a7,7,0,1,0-7-7,7,7,0,0,0,7,7"
    /><path
        class="cls-2"
        d="M908.39,155.47a5.53,5.53,0,1,0-5.52-5.53,5.53,5.53,0,0,0,5.52,5.53"
    /><path
        class="cls-2"
        d="M888.92,166.38a6.67,6.67,0,1,0-6.66-6.67,6.66,6.66,0,0,0,6.66,6.67"
    /><path class="cls-1" d="M755.08,124.59a7.8,7.8,0,1,0,7.79,7.8,7.8,7.8,0,0,0-7.79-7.8" /><path
        class="cls-1"
        d="M734.57,125.58a6.81,6.81,0,1,0,6.81,6.81,6.81,6.81,0,0,0-6.81-6.81"
    /><path class="cls-1" d="M700,127.09a5.3,5.3,0,1,0,5.3,5.29,5.3,5.3,0,0,0-5.3-5.29" /><path
        class="cls-1"
        d="M683.75,127.47a4.92,4.92,0,1,0,4.92,4.92,4.92,4.92,0,0,0-4.92-4.92"
    /><path
        class="cls-1"
        d="M804.49,56.69a8.18,8.18,0,1,0,8.17,8.18,8.18,8.18,0,0,0-8.17-8.18"
    /><path
        class="cls-1"
        d="M791.87,76.36a8.18,8.18,0,1,0,8.18,8.17,8.17,8.17,0,0,0-8.18-8.17"
    /><path
        class="cls-1"
        d="M744.16,87.81a7.57,7.57,0,1,0,7.57,7.57,7.57,7.57,0,0,0-7.57-7.57"
    /><path class="cls-1" d="M737.15,107.22a7,7,0,1,0,7,7,7,7,0,0,0-7-7" /><path
        class="cls-1"
        d="M726.1,77.17a7.57,7.57,0,1,0,7.57,7.57,7.57,7.57,0,0,0-7.57-7.57"
    /><path
        class="cls-1"
        d="M768.72,82.66a8.18,8.18,0,1,0,8.18,8.17,8.17,8.17,0,0,0-8.18-8.17"
    /><path class="cls-1" d="M758.92,102.9a7.94,7.94,0,1,0,8,7.94,7.94,7.94,0,0,0-8-7.94" /><path
        class="cls-1"
        d="M777.46,59.41a8.18,8.18,0,1,0,8.18,8.17,8.17,8.17,0,0,0-8.18-8.17"
    /><path
        class="cls-1"
        d="M751.2,66.56a8.18,8.18,0,1,0,8.18,8.18,8.18,8.18,0,0,0-8.18-8.18"
    /><path
        class="cls-1"
        d="M700.57,109.32a5.53,5.53,0,1,0,5.53,5.52,5.52,5.52,0,0,0-5.53-5.52"
    /><path class="cls-1" d="M717,117.54a5.91,5.91,0,1,0,5.9,5.91,5.91,5.91,0,0,0-5.9-5.91" /><path
        class="cls-1"
        d="M683.75,105a4.92,4.92,0,1,0,4.92,4.92,4.92,4.92,0,0,0-4.92-4.92"
    /><path
        class="cls-1"
        d="M720.05,98.4a6.66,6.66,0,1,0,6.66,6.66,6.66,6.66,0,0,0-6.66-6.66"
    /><path
        class="cls-1"
        d="M703.38,90.09a6.21,6.21,0,1,0,6.2,6.21,6.21,6.21,0,0,0-6.2-6.21"
    /><path
        class="cls-1"
        d="M804.49,208.09a8.18,8.18,0,1,1,8.17-8.18,8.18,8.18,0,0,1-8.17,8.18"
    /><path class="cls-1" d="M737.15,157.57a7,7,0,1,1,7-7,7.05,7.05,0,0,1-7,7" /><path
        class="cls-1"
        d="M726.1,187.62a7.57,7.57,0,1,1,7.57-7.57,7.57,7.57,0,0,1-7.57,7.57"
    /><path class="cls-1" d="M758.92,161.89a7.95,7.95,0,1,1,8-7.95,7.95,7.95,0,0,1-8,7.95" /><path
        class="cls-1"
        d="M777.46,205.37a8.17,8.17,0,1,1,8.18-8.17,8.17,8.17,0,0,1-8.18,8.17"
    /><path
        class="cls-1"
        d="M751.2,198.23a8.18,8.18,0,1,1,8.18-8.18,8.18,8.18,0,0,1-8.18,8.18"
    /><path class="cls-1" d="M717,147.24a5.91,5.91,0,1,1,5.9-5.91,5.91,5.91,0,0,1-5.9,5.91" /><path
        class="cls-1"
        d="M683.75,159.81a4.92,4.92,0,1,1,4.92-4.92,4.92,4.92,0,0,1-4.92,4.92"
    /><path
        class="cls-1"
        d="M703.38,174.7a6.21,6.21,0,1,1,6.2-6.21,6.21,6.21,0,0,1-6.2,6.21"
    /><path class="cls-1" d="M853.9,124.59a7.8,7.8,0,1,1-7.79,7.8,7.8,7.8,0,0,1,7.79-7.8" /><path
        class="cls-1"
        d="M874.4,125.58a6.81,6.81,0,1,1-6.81,6.81,6.81,6.81,0,0,1,6.81-6.81"
    /><path class="cls-1" d="M909,127.09a5.3,5.3,0,1,1-5.3,5.29,5.3,5.3,0,0,1,5.3-5.29" /><path
        class="cls-1"
        d="M925.23,127.47a4.92,4.92,0,1,1-4.93,4.92,4.91,4.91,0,0,1,4.93-4.92"
    /><path
        class="cls-1"
        d="M817.1,76.36a8.18,8.18,0,1,1-8.17,8.17,8.18,8.18,0,0,1,8.17-8.17"
    /><path
        class="cls-1"
        d="M864.81,87.81a7.57,7.57,0,1,1-7.57,7.57,7.56,7.56,0,0,1,7.57-7.57"
    /><path class="cls-1" d="M871.83,107.22a7,7,0,1,1-7,7,7,7,0,0,1,7-7" /><path
        class="cls-1"
        d="M882.87,77.17a7.57,7.57,0,1,1-7.56,7.57,7.57,7.57,0,0,1,7.56-7.57"
    /><path
        class="cls-1"
        d="M840.25,82.66a8.18,8.18,0,1,1-8.17,8.17,8.17,8.17,0,0,1,8.17-8.17"
    /><path
        class="cls-1"
        d="M850.05,102.9a7.94,7.94,0,1,1-7.95,7.94,7.94,7.94,0,0,1,7.95-7.94"
    /><path
        class="cls-1"
        d="M831.51,59.41a8.18,8.18,0,1,1-8.17,8.17,8.17,8.17,0,0,1,8.17-8.17"
    /><path
        class="cls-1"
        d="M857.78,66.56a8.18,8.18,0,1,1-8.18,8.18,8.17,8.17,0,0,1,8.18-8.18"
    /><path
        class="cls-1"
        d="M908.39,109.32a5.53,5.53,0,1,1-5.52,5.52,5.52,5.52,0,0,1,5.52-5.52"
    /><path class="cls-1" d="M892,117.54a5.91,5.91,0,1,1-5.9,5.91,5.92,5.92,0,0,1,5.9-5.91" /><path
        class="cls-1"
        d="M925.23,105a4.92,4.92,0,1,1-4.93,4.92,4.92,4.92,0,0,1,4.93-4.92"
    /><path
        class="cls-1"
        d="M888.92,98.4a6.66,6.66,0,1,1-6.66,6.66,6.66,6.66,0,0,1,6.66-6.66"
    /><path
        class="cls-1"
        d="M905.59,90.09a6.21,6.21,0,1,1-6.2,6.21,6.21,6.21,0,0,1,6.2-6.21"
    /><path class="cls-1" d="M871.83,157.57a7,7,0,1,0-7-7,7,7,0,0,0,7,7" /><path
        class="cls-1"
        d="M882.87,187.62a7.57,7.57,0,1,0-7.56-7.57,7.57,7.57,0,0,0,7.56,7.57"
    /><path class="cls-1" d="M850.05,161.89a7.95,7.95,0,1,0-7.95-7.95,8,8,0,0,0,7.95,7.95" /><path
        class="cls-1"
        d="M831.51,205.37a8.17,8.17,0,1,0-8.17-8.17,8.17,8.17,0,0,0,8.17,8.17"
    /><path
        class="cls-1"
        d="M857.78,198.23a8.18,8.18,0,1,0-8.18-8.18,8.18,8.18,0,0,0,8.18,8.18"
    /><path class="cls-1" d="M892,147.24a5.91,5.91,0,1,0-5.9-5.91,5.92,5.92,0,0,0,5.9,5.91" /><path
        class="cls-1"
        d="M925.23,159.81a4.92,4.92,0,1,0-4.93-4.92,4.92,4.92,0,0,0,4.93,4.92"
    /><path class="cls-1" d="M905.59,174.7a6.21,6.21,0,1,0-6.2-6.21,6.21,6.21,0,0,0,6.2,6.21" />
</svg>

<style>
    .cls-2 {
        fill: #a84d97;
    }
    .cls-1 {
        fill: #ffffff;
    }
</style>
